import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {CruiseControlSettingsInterface} from '../../../../../model/cruise-control-settings.interface';
import {UserService} from '../../../../../service/user.service';

@Component({
  selector: 'auto-cruise-control-form',
  templateUrl: './cruise-control-form.component.html',
  styleUrl: './cruise-control-form.component.scss',
  standalone: false
})
export class CruiseControlFormComponent implements OnInit, OnDestroy {
  readonly userService: UserService;
  @Input() accountId: number;
  @Input() settings: CruiseControlSettingsInterface;
  @Input() label: string;
  readonly cruiseControlRedesignFeatureName: string = 'cruiseControlRedesign';
  isCruiseControlRedesignEnabled: boolean = false;
  destroySubject: Subject<void> = new Subject<void>();

  constructor(userService: UserService) {
    this.userService = userService;
  }

  ngOnInit(): void {
    this.loadCruiseControlRedesignFeatureFlag();
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  loadCruiseControlRedesignFeatureFlag(): void {
    this.userService.getMpopFeature(this.cruiseControlRedesignFeatureName)
      .pipe(takeUntil(this.destroySubject))
      .subscribe({
        next: (features) => {
          const feature = features.shift();

          if (feature) {
            this.isCruiseControlRedesignEnabled = feature.enabled === true;
          }
        },
        error: () => {
          this.isCruiseControlRedesignEnabled = false;
        }
      });
  }
}
